module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "flexbetween"
  }, [(_vm.isDocomo) ? _c('div', {
    staticClass: "navigation menu-bar"
  }) : _c('div', {
    staticClass: "navigation menu-bar"
  }, [_c('popover', {
    attrs: {
      "name": "navigation-left",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    staticClass: "btn-menu-bar",
    attrs: {
      "slot": "face"
    },
    slot: "face"
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/logo-s.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navigation-left-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.goLibrary
    }
  }, [_vm._v("ライブラリへ戻る")])])])])], 1), _vm._v(" "), (_vm.isCurrentViewHome) ? _c('div', {
    staticClass: "contentname lbold sp-top"
  }, [_vm._v(_vm._s(_vm.contentName))]) : (_vm.isEnvironmentPc()) ? _c('div', {
    staticClass: "contentname lbold"
  }, [_vm._v(_vm._s(_vm.contentName) + " : レッスン " + _vm._s(_vm.lessonIndex + 1) + " " + _vm._s(_vm.pathTitle))]) : _c('div', {
    staticClass: "contentname lbold"
  }, [_vm._v(_vm._s(_vm.contentName)), _c('br'), _vm._v("レッスン " + _vm._s(_vm.lessonIndex + 1) + " " + _vm._s(_vm.pathTitle))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCurrentViewHome),
      expression: "!isCurrentViewHome"
    }],
    staticClass: "sp-second-header"
  }, [_c('div', {
    staticClass: "items flexcenter"
  }, [_c('div', {
    staticClass: "progress font18"
  }, [_c('span', {
    staticClass: "textred"
  }, [_vm._v(_vm._s(_vm.pathstepIndex + 1))]), _vm._v(" / " + _vm._s(_vm.pathstepLength))]), _vm._v(" "), _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCurrentViewHome),
      expression: "!isCurrentViewHome"
    }],
    staticClass: "setting-lang"
  }, [_c('popover', {
    attrs: {
      "name": "answer",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "face"
    },
    slot: "face"
  }, [(_vm.checkJPFlg) ? _c('div', {
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/icon/header/lang-ja.png")
    }
  })]) : (_vm.checkAllFlg) ? _c('div', {
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/icon/header/lang-en.png")
    }
  })]) : _c('div', {
    staticClass: "btn-lang"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/icon/header/lang-en-t.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lang-status",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.checkJPFlg
    },
    on: {
      "click": _vm.clickJP
    }
  }, [_vm._v("日本語翻訳を表示する")]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.checkAllFlg
    },
    on: {
      "click": _vm.clickAll
    }
  }, [_vm._v("全解答を表示する")])])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCurrentViewHome),
      expression: "!isCurrentViewHome"
    }],
    staticClass: "setting-score"
  }, [_c('div', {
    staticClass: "btn-score",
    on: {
      "click": _vm.clickLessonScore
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/icon/header/score.png")
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "navigation menu-dots"
  }, [_c('popover', {
    attrs: {
      "name": "navigation-right",
      "closeOnContentClick": true
    }
  }, [_c('div', {
    staticClass: "btn-menu-dots",
    attrs: {
      "slot": "face"
    },
    on: {
      "click": function($event) {
        return _vm.clickMenu()
      }
    },
    slot: "face"
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/header/setting-dots.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navigation-right-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', [(!_vm.isCurrentViewHome) ? _c('li', {
    on: {
      "click": _vm.clickLogo
    }
  }, [_vm._v("ホームへ戻る")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.clickSettingButton
    }
  }, [_vm._v("設定")]), _vm._v(" "), (_vm.isDocomo || _vm.isAu) ? _c('li', {
    staticClass: "docomo_push"
  }, [_c('div', {
    staticClass: "flexstart"
  }, [_c('span', [_vm._v("プッシュ通知を許可")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: _vm.isEnablePush
    },
    on: {
      "click": _vm.clickNotification
    }
  }, [_vm._v("ON")]), _c('span', {
    staticClass: "push_option",
    class: {
      active: !_vm.isEnablePush
    },
    on: {
      "click": _vm.clickNotification
    }
  }, [_vm._v("OFF")])]), _vm._v(" "), (!_vm.isAu) ? _c('div', {
    staticClass: "font14 lbold ml10 mt10"
  }, [_vm._v("月に1~3回程度アップデート案内します。")]) : _vm._e(), _vm._v(" "), (!_vm.isAu) ? _c('div', {
    staticClass: "font14 ml10"
  }, [_c('span', [_vm._v("らくらくスマートフォン等の非対応機種では配信されません。")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isDocomo && !_vm.isAu) ? _c('li', [_c('a', {
    staticClass: "helptext",
    attrs: {
      "href": "http://www.sourcenext.com/manual_sc/pc/rosettastone_advanced/home/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.clickLink('help')
      }
    }
  }, [_vm._v("ヘルプ")])]) : _vm._e(), _vm._v(" "), (!_vm.isDocomo && !_vm.isAu) ? _c('li', [_c('a', {
    staticClass: "readme",
    attrs: {
      "href": "https://www.sourcenext.com/r/p/rosettastone/eula/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.clickLink('readme')
      }
    }
  }, [_vm._v("Rosetta Stone について")])]) : _vm._e(), _vm._v(" "), (_vm.isDocomo) ? _c('li', {
    on: {
      "click": _vm.clickPrivacyPolicy
    }
  }, [_vm._v("プライバシーポリシー")]) : _vm._e(), _vm._v(" "), (_vm.isAu) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.getContactUrl(),
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.clickLink('contact')
      }
    }
  }, [_vm._v("お問い合わせ")])]) : _vm._e(), _vm._v(" "), (_vm.isAu) ? _c('li', [_c('a', {
    attrs: {
      "href": "http://www.sourcenext.com/r/p/au/rosetta_us/support/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.clickLink('faq')
      }
    }
  }, [_vm._v("FAQ")])]) : _vm._e(), _vm._v(" "), (_vm.isAu) ? _c('li', [_c('a', {
    attrs: {
      "href": "http://www.sourcenext.com/r/p/au/rosetta_us/product/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.clickLink('product')
      }
    }
  }, [_vm._v("製品紹介")])]) : _vm._e()]), _vm._v(" "), (_vm.note.length != 0) ? _c('div', {
    staticClass: "hintArea"
  }, [_c('div', {
    staticClass: "hint"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/icon/header/hint.png")
    }
  }), _vm._v("ヒント")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.note))])]) : _vm._e()])])], 1)])])]), _vm._v(" "), (_vm.showLogout) ? _c('Logout', {
    attrs: {
      "productInfo": _vm.productInfo
    },
    on: {
      "closeLogout": _vm.closeLogout
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c37f4b7a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-c37f4b7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 641
// module chunks = 1